export default "__VITE_ASSET__6ca5c4ce__"